"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var SimplifyFormInput_1 = __importDefault(require("shared/components/Form/HoC/SimplifyFormInput"));
var TextField_1 = __importDefault(require("shared/components/Form/TextField"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var backend_1 = require("utils/backend");
var SimpleTextField = (0, SimplifyFormInput_1.default)(TextField_1.default);
var TestTransactionMapping = function () {
    var _a = __read(react_1.default.useState(''), 2), transactionId = _a[0], setTransactionId = _a[1];
    var _b = __read(react_1.default.useState(''), 2), debugSrvName = _b[0], setDebugSrvName = _b[1];
    var _c = __read(react_1.default.useState(null), 2), requestResult = _c[0], setRequestResult = _c[1];
    var _d = __read((0, backend_1.useCall)('serviceStats-testTransactionMapping'), 2), testTransactionMapping = _d[0], isSending = _d[1];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 2, mb: 1 }, { children: "Debug Transaction Mapping" })), (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ width: 500 }, { children: (0, jsx_runtime_1.jsx)(SimpleTextField, { placeholder: "Transaction ID", value: transactionId, onChange: setTransactionId }) })), (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ width: 500 }, { children: (0, jsx_runtime_1.jsx)(SimpleTextField, { placeholder: "Service Name To Debug", value: debugSrvName, onChange: setDebugSrvName }) })), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: function () { return testTransactionMapping({ transactionId: transactionId, isDebug: true, debugSrvName: debugSrvName })().then(function (r) { return setRequestResult(r === null || r === void 0 ? void 0 : r.data); }); }, isSending: isSending, disabled: !transactionId || isSending }, { children: "Test Transaction Mapping" })), requestResult && (0, jsx_runtime_1.jsx)("pre", { children: JSON.stringify(requestResult, null, 2) })] }));
};
exports.default = TestTransactionMapping;
